<template>
  <div>
    <el-upload
      :action="uploadUrl"
      :headers="{'Authorization': 'Bearer ' + token, 'AppCode' : 'roses-platform'}"
      :multiple="false"
      :file-list="defaultList"
      :limit="limitNum"
      :before-upload="beforeUpload"
      :on-exceed="handleExceed"
      :on-success="handleSuccess"
      :on-remove="handleRemove"
      :on-preview="handlePictureCardPreview"
      list-type="picture"
      :accept="acceptType"
    >
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip" style="margin-left:16px">只能上传{{limitNum}}个文件</div>
    </el-upload>

    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import config from '../config/index.js';
import { mapGetters } from 'vuex';

export default {
  props: {
    defaultList: {
      type: Array,
      default: () => []
    },
    limitNum: {
      type: Number,
      default: 1
    },
    acceptType: {
      type: String,
      default: '.jpg, .png, .gif, .jpge, .jpeg'
    }
  },
  computed: {
    ...mapGetters(['token']),
    uploadUrl() {
      return `${config.base_url}/roses-pub-service/sysFileInfo/upload`;
    }
  },
  data() {
    return {
      config,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      fileIdList: []
    };
  },
  created() {},
  methods: {
    handleRemove(file) {
      let removeFileId = '';
      if (file.response) {
        removeFileId = file.response.data;
      } else {
        removeFileId = file.id;
      }
      this.fileIdList.splice(this.fileIdList.indexOf(removeFileId), 1);
      this.$emit('get-file-data', this.fileIdList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeUpload(file) {
      // console.log(file);
      let requireType = '';
      if (this.acceptType === '.apk') {
        requireType = ['application/vnd.android.package-archive'];
      } else {
        requireType = ['image/jpg', 'image/png', 'image/gif', 'image/jpge', 'image/jpeg'];
      }

      const isRequireType = requireType.indexOf(file.type) >= 0;
      if (!isRequireType) {
        this.$message.error('上传文件类型错误!');
      }

      // const isLt10M = file.size / 1024 / 1024 < 10;
      // if (!isLt10M) {
      //   this.$message({
      //     message: `上传图片大小不能超过 10MB!`,
      //     type: 'error'
      //   });
      // }

      // return isLt10M && isRequireType;
      return isRequireType;
    },
    // 超出文件个数钩子
    handleExceed() {
      this.$message({
        message: `最多只能上传${this.limitNum}个文件`,
        type: 'error'
      });
    },
    handleSuccess(response) {
      this.fileIdList.push(response.data);
      this.$emit('get-file-data', this.fileIdList);
    }
  },
  watch: {
    defaultList(newVal) {
      this.fileIdList = [];
      newVal.forEach(item => {
        this.fileIdList.push(item.id);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.el-upload__tip {
  display: inline;
}
</style>
